import { render, staticRenderFns } from "./AccettazioneSsnPrestazioniComponent.vue?vue&type=template&id=6c7be600&scoped=true"
import script from "./AccettazioneSsnPrestazioniComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnPrestazioniComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnPrestazioniComponent.vue?vue&type=style&index=0&id=6c7be600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7be600",
  null
  
)

export default component.exports